import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from '@/utils/axios'
import 'lib-flexible'

Vue.config.productionTip = false
Vue.prototype.$axios = Axios //引用axios
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
